/**
 * The kit's grounds as values, for code that needs a colour as a number rather than a `var()`: the brand
 * colour derivation (docs/brand-colour-tokens.md) and the browser's theme-color. They mirror the shades in
 * styles/theme.css; the account portal's colour token test holds the two equal, so neither can drift.
 */
export const kitGrounds = {
    /** --shade-09 (the page) and --shade-10 (the card). */
    light: { page: "#f1f1f1", card: "#fdfdfd" },
    /** --shade-02 (the page) and --shade-03 (the card). */
    dark: { page: "#101010", card: "#191919" },
} as const;

/**
 * The ground each theme's brand roles are derived against: the surface a colour reads worst on, so it reads
 * on every surface of that theme. Light: the page, the darker of the two. Dark: the card, the lighter.
 */
export const brandGround = { light: kitGrounds.light.page, dark: kitGrounds.dark.card } as const;
